import { createSlice } from '@reduxjs/toolkit'

export interface BearerTokenState {
    value: string
}

const initialState: BearerTokenState = {
    value: "",
}

export const bearerTokenSlice = createSlice({
    name: 'bearerToken',
    initialState,
    reducers: {
        addBearerToken: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.value = action.payload;
            sessionStorage.setItem("bearerToken", action.payload);
        },
        removeBearerToken: (state) => {
            state.value = "";
            sessionStorage.setItem("bearerToken", "");
        }
    }
})

// Action creators are generated for each case reducer function
export const { addBearerToken, removeBearerToken } = bearerTokenSlice.actions

export default bearerTokenSlice.reducer



